require('./policies.style.scss');

const policiesModule = angular.module('com.comtrade.azureCloud.backup.policies', []);

policiesModule.component('policies', require('./policies.component'));
policiesModule.component('policyAddEditDialog', require('./dialogs/policyAddEditDialog/policyAddEditDialog.component'));
policiesModule.component('policyBackupWindowDialog', require('./dialogs/policyBackupWindowDialog/policyBackupWindowDialog.component'));
policiesModule.component('policyArchiving', require('./dialogs/policyArchiving/policyArchiving.component'));

policiesModule.service('policiesPersistence', require('./policies.persistence.service'));
policiesModule.service('policiesUtils', require('./policies.utils'));

module.exports = policiesModule;



// WEBPACK FOOTER //
// ./src/azurebackup/views/policies/policies.module.js